import React, { useState, useEffect,useRef } from "react";
// import { useRouteMatch, withRouter } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { Popup } from '@progress/kendo-react-popup';
import {
  Menu,
  MenuItem,
  MenuSelectEvent,
  MenuItemLink,
} from "@progress/kendo-react-layout";
import { useAppDispatch } from "./store.hooks";
import {
  toggleSidebar,
  getSidebarStatusSelector,
} from "../Common/Slices/SidebarSlice";
import {
  getDialogSelector,
  updateShareVisible,
} from "../Common/Slices/DialogSlice";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { useSelector } from "react-redux";
import { getParamsSelector } from "../Common/Slices/ParamSlice";
import Settings from "../Settings";
import Information from "../Information";
import Taskboard from "../Taskboard";
import ExternalNav from "./ExternalNav";
import FleetNav from "./FleetNav";
import UserInfo from "../UserInfo";
import { toggleMenu } from "../Common/Slices/MenuSlice";
import { AuthApi } from "../Core/api";

const ppLogoStyle = { width: "81px", height: "29px", cursor: "pointer" }; //inline to override semantic list:img css
const backgroundMenu = {
  backgroundColor: "white",
  color: "#1a171b",
  fontSize: "1.2rem",
  padding: "8px",
};

const linkRender = (props: any) => {
  return (
    <MenuItemLink url={props.item.url} opened={props.opened}>
      {[renderMenuIconIfApplicable(props), props.item.text, null]}
    </MenuItemLink>
  );
};

function renderMenuIconIfApplicable(props: any) {
  return props.item.icon ? (
    <span
      style={{ fontSize: "20px", color: "#fff" }}
      className={`k-icon k-i-${props.item.icon}`}
      role="presentation"
      key="0"
    />
  ) : null;
}

const Navigation = (props: any) => {

  const anchor = React.useRef();
  const params = useSelector(getParamsSelector);
  const shareVisible = useSelector(getDialogSelector).shareVisible;
  const sidebarStatus = useSelector(getSidebarStatusSelector);

  const navigate = useNavigate();
    const [settingsVisible, updateSettingsVisble] = useState(false);
    const [userInfoVisible, updateUserInfoVisible] = useState(false);
  const [informationVisible, updateInformationVisible] = useState(false);
  const [taskboardVisible, updateTaskboardVisible] = useState(false);
  const [externalNavVisible, updateExternalNavVisible] = useState(false);
  const [selectedRoute, updateSelectedRoute] = useState("/search");

  const [menuOpen, updateMenuOpen] = useState(true);
  const [sidebarOpen, updateSidebarOpen] = useState(true);
  const dispatch = useAppDispatch();

  useEffect(() => {
    updateSidebarOpen(sidebarStatus);
  }, [sidebarStatus]);
  const location = useLocation();
  useEffect(() => {

      let newRoute = location.pathname;
      if (newRoute == "/") newRoute = "/search";
      updateSelectedRoute(newRoute);
  }, [location]);

  

  const toggleSidebarOpen = () => {
    const toggle = !sidebarOpen;
    updateSidebarOpen(toggle);
    dispatch<any>(toggleSidebar({ isOpen: toggle }));
  };
  const toggleMenuOpen = () => {
    const toggle = !menuOpen;
    updateMenuOpen(toggle);
    dispatch(toggleMenu({ isOpen: toggle }));
  };
  const onSelect = (event: MenuSelectEvent) => {
      if (event.item.data && event.item.data.route && event.item.data.route != "/customers") {
          updateSelectedRoute(event.item.data.route);
          navigate(event.item.data.route, { state: params });
      }
      else if (event.item.data.route == "/customers") {
          alert("Select a customer or machine to view dashboards")
      }
  };

    const shareHandler = () => {
        if (shareVisible) {
            dispatch(updateShareVisible(false));
            AuthApi.logUserEvent("Share");
        } else {
            dispatch(updateShareVisible(true));
        }
    };

    const toggleSettings = () => {
        if (settingsVisible) {
            updateSettingsVisble(false);
            AuthApi.logUserEvent("Settings");
        } else {
            updateSettingsVisble(true);
        }
    };

    const toggleInformation = () => {
        if (informationVisible) {
            updateInformationVisible(false);
            AuthApi.logUserEvent("Information");
        } else {
            updateInformationVisible(true);
        }
    };

    const toggleTaskboard = () => {
        if (taskboardVisible) {
            updateTaskboardVisible(false);
            AuthApi.logUserEvent("Taskboard");
        } else {
            updateTaskboardVisible(true);
        }
    };

    const toggleExternalNav = () => {
        if (externalNavVisible) {
            updateExternalNavVisible(false);
            AuthApi.logUserEvent("External Nav");
        } else {
            updateExternalNavVisible(true);
        }
    };


    const toggleUserInfo = () => {
       userInfoVisible
            ? updateUserInfoVisible(false)
            : updateUserInfoVisible(true);
    };
  const logout = () => {
    props.logOut();
  };

  const sidebarIconColor = () => {
    // console.log(sidebarOpen);
    if (sidebarOpen) {
      return "#fff";
    } else {
      return "#4fb9ff";
    }
  };
  const getMenuItemStyle = (text: string) => {
    if ("/" + text == selectedRoute) {
      return { color: "#4fb9ff ", backgroundColor: "#1a171b" };
    } else {
      return { backgroundColor: "#1a171b", color: "#fff" };
    }
  };
  const menuIconColor = () => {
    if (menuOpen) {
      return "#fff";
    } else {
      return "#4fb9ff";
    }
  };
    const renderSubMenu = () => {
        if (selectedRoute == "/customers" || selectedRoute =="/search") {
            return (<div className="navBar3">
                <Menu onSelect={onSelect} vertical={false}>
                    
                    <MenuItem
                        text="Search"
                        // data={{ route: `${match.path}/` }}
                        data={{ route: "/search" }}
                        cssStyle={getMenuItemStyle("search")}
                    />
                    <MenuItem
                        text="Dashboards"
                        // data={{ route: `${match.path}/` }}
                        data={{ route: "/customers" }}
                        cssStyle={getMenuItemStyle("customers")}
                    />

                </Menu>{" "}
            </div>)
        }
        else {
            return (<div className="navBar3">
                <Menu onSelect={onSelect} vertical={false}>
                    <MenuItem
                        text="JIRA Reports"
                        // data={{ route: `${match.path}/` }}
                        data={{ route: "/jiraReports" }}
                        cssStyle={getMenuItemStyle("jiraReports")}
                    />
                    <MenuItem
                        text="Service Reports Archive"
                        //data={{ route: `${match.path}/` }}
                        data={{ route: "/events" }}
                        cssStyle={getMenuItemStyle("events")}
                    />
                    <MenuItem
                        text="PST Customers"
                        // data={{ route: `${match.path}/` }}
                        data={{ route: "/pstSearch" }}
                        cssStyle={getMenuItemStyle("pstSearch")}
                    />
                    <MenuItem
                        text="MPE Devices"
                        // data={{ route: `${match.path}/` }}
                        data={{ route: "/mpeSearch" }}
                        cssStyle={getMenuItemStyle("mpeSearch")}
                    />

                </Menu>{" "}
            </div>)
        }
    }
  const renderMenu = () => {
    if (menuOpen) {
      return (
        <>
          {" "}
              <div className="navBar2">
                  <FleetNav params={params} subMenuItem={selectedRoute } />
              </div>
              {renderSubMenu()}
        </>
      );
    }
  };

  return (
    <div>
      <div className="navBar">
        <div className="navigationMenu">
          {/*        <img src="../../assets/img/prima_logo_w.png" style={ppLogoStyle} onClick={() => window.open("https://home.powerplatform.net/", "_self")} />*/}
          <img src="../../assets/img/prima_logo_w.png" style={ppLogoStyle} />
          <SvgIcon
            style={{ color: menuIconColor(), cursor: "pointer" }}
            icon={svgIcons.menuIcon}
            size="medium"
            onClick={() => toggleMenuOpen()}
          />
          <SvgIcon
            style={{ color: sidebarIconColor(), cursor: "pointer" }}
            icon={svgIcons.slidersIcon}
            size="medium"
            onClick={() => toggleSidebarOpen()}
          />
        </div>
        <p
          className="pp-header-text "
          style={{
            fontWeight: "bold",
            fontSize: "17px",
          }}
        >
          <span style={{ cursor: "pointer" }}>FLEET MANAGEMENT</span>
        </p>
        <span className="right">
          {" "}
          <SvgIcon
            style={{
              color: "#fff",
              cursor: "pointer",
              marginRight: "20px",
              fontSize: "28px",
            }}
            icon={svgIcons.shareIcon}
            size="medium"
            onClick={() => shareHandler()}
          />
          <SvgIcon
            style={{
              color: "#fff",
              cursor: "pointer",
              marginRight: "20px",
              fontSize: "28px",
            }}
            icon={svgIcons.linkIcon}
            size="medium"
            onClick={() => toggleExternalNav()}
          />
          {/*<SvgIcon*/}
          {/*  style={{*/}
          {/*    color: "#fff",*/}
          {/*    cursor: "pointer",*/}
          {/*    marginRight: "20px",*/}
          {/*    fontSize: "28px",*/}
          {/*  }}*/}
          {/*  icon={svgIcons.clipboardTextIcon}*/}
          {/*  size="medium"*/}
          {/*  onClick={() => toggleTaskboard()}*/}
          {/*/>*/}
          <SvgIcon
            style={{
              color: "#fff",
              cursor: "pointer",
              marginRight: "20px",
              fontSize: "27px",
            }}
            icon={svgIcons.questionCircleIcon}
            size="medium"
            onClick={() => toggleInformation()}
          />
          <SvgIcon
            style={{
              color: "#fff",
              cursor: "pointer",
              marginRight: "30px",
              fontSize: "28px",
            }}
            icon={svgIcons.gearsIcon}
            size="medium"
            onClick={() => toggleSettings()}
                  /><span ref={anchor}>
            <SvgIcon
                style={{
                    color: "#fff",
                    cursor: "pointer",
                    marginRight: "30px",
                    fontSize: "28px",
                }}
                icon={svgIcons.userIcon}
                size="large"
                      onClick={() => toggleUserInfo()}
                     
            /></span>
       
        </span>
        <Settings visible={settingsVisible} toggleVisible={toggleSettings} />
        <Information
          visible={informationVisible}
          toggleVisible={toggleInformation}
          id="101"
        />
        <Taskboard visible={taskboardVisible} toggleVisible={toggleTaskboard} />
        <ExternalNav
          visible={externalNavVisible}
          toggleVisible={toggleExternalNav}
          selectedRoute={selectedRoute}
          params={params}
              />
              {anchor.current && (
                  <Popup anchor={anchor.current} show={userInfoVisible} className={'wrapper'} popupClass={'inner-wrapper'} style={{  zIndex: 99999999 }}>
                      <UserInfo toggleVisible={toggleUserInfo} logOut={logout} />
              </Popup>
            )}
            </div>
      {renderMenu()}
    </div>
  );
};

export default Navigation;
